<template>
  <a :href="resolved.href" :class="btnClass">
    <slot>{{ resolved.label }}</slot>
  </a>
</template>

<script setup>
import { computed } from 'vue';
import { useSession } from '../composables/useSession.js';

const props = defineProps({
  variant: { type: String, default: 'primary' },
  size: { type: String, default: '' },
  plan: { type: String, default: '' },
  cycle: { type: String, default: 'monthly' },
  label: { type: String, default: '' },
  href: { type: String, default: '' },
  mode: { type: String, default: 'auto' },
});

const { isAuthenticated, ctaForPlan, loginUrl, signupUrl, dashboardUrl } = useSession();

const resolved = computed(() => {
  if (props.href) {
    return { href: props.href, label: props.label || 'Continue' };
  }
  if (props.mode === 'login') {
    return { href: loginUrl, label: props.label || 'Login' };
  }
  if (props.plan) {
    const cta = ctaForPlan(props.plan, props.cycle);
    return { ...cta, label: props.label || cta.label };
  }
  if (isAuthenticated.value) {
    return { href: dashboardUrl, label: props.label || 'Go to dashboard' };
  }
  return { href: signupUrl, label: props.label || 'Get started free' };
});

const btnClass = computed(() => {
  const classes = ['btn'];
  if (props.variant === 'primary') classes.push('btn-primary');
  else if (props.variant === 'ghost') classes.push('btn-ghost');
  else if (props.variant === 'link') classes.push('btn-link');
  if (props.size === 'lg') classes.push('btn-lg');
  if (props.size === 'sm') classes.push('btn-sm');
  return classes;
});
</script>
